import React from 'react';
import { IndexRoute, Route } from 'react-router';

import App from 'views/App';
import Home from 'AppViews/Home';
import Charger from 'AppViews/Charger';
import Place from 'AppViews/Place';
import Ranking from 'AppViews/Ranking';
import User from 'AppViews/User';
import UserRegister from 'AppViews/UserRegister';
import UserAccount from 'AppViews/UserAccount';
import Login from 'AppViews/Login';
import PasswordReset from 'AppViews/PasswordReset';
import NotFound from 'AppViews/NotFound';
import Page from 'AppViews/Page';
import Contact from 'AppViews/Page/Contact';
import Privacy from 'AppViews/Page/Privacy';
import UserRankings from 'AppViews/UserRankings';

const loginRequired = store => (
  (nextState, replace) => {
    const redux = store.getState();
    if (!redux.auth.isLoggedIn) {
      replace({
        pathname: '/user/login',
        state: { nextPathname: nextState.location.pathname },
      });
    }
  }
);

const getPageComponent = slug => (
  (nextState, callback) => {
    callback(null, props => (
      <Page slug={slug} {...props} />
    ));
  }
);

export default store => (
  <Route path='/' component={App}>
    <IndexRoute name='home' component={Home} />

    <Route name='charger-detail' path='/charger/:chargerId' component={Charger} />
    <Route name='charger-places' path='/charger/:chargerId/#places' component={Charger} />

    <Route name='rankings' path='/rankings' component={Ranking} />

    <Route name='user-rankings' path='/rankings/user' component={UserRankings} />

    <Route path='user'>
      <Route name='login' path='login' component={Login} />
      <Route
        name='user-account'
        path='account'
        component={UserAccount}
        onEnter={loginRequired(store)}
      />
      <Route
        name='user-password-reset'
        path='account/password/reset/:userId/:token'
        component={PasswordReset}
      />
      <Route name='user-register' path='register' component={UserRegister} />
      <Route name='user-profile' path=':username' component={User} />
    </Route>

    <Route name='place-detail' path='/:placeType/:placeId' component={Place} />

    <Route name='about' path='/about' getComponent={getPageComponent('about')} />
    <Route name='privacy' path='/privacy' component={Privacy} />
    <Route name='contact' path='/contact' component={Contact} />

    <Route name='not-found' path='*' component={NotFound} />
  </Route>
);



// WEBPACK FOOTER //
// ./app/scripts/config/routes.jsx